module.exports = __webpack_public_path__ + "static/media/medicine.e79de8e8.svg";